import React, { ReactHTML } from 'react'
import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/Card'
import { XMarkIcon } from '@heroicons/react/16/solid'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import useCloseToOrigin from '@/hooks/useCloseToOrigin'
import { Skeleton } from '@/components/ui/skeleton'

const Header = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    // <CardFooter
    //   className={cn(
    //     'flex flex-row justify-end gap-2 border-t px-4 py-4',
    //     className,
    //   )}
    //   {...props}
    // ></CardFooter>
    <CardHeader
      data-slot="nmw-header"
      className={cn(
        'flex flex-row items-center justify-between overflow-auto border-b border-light px-4 py-3 font-medium',
        className,
      )}
      {...props}
    >
      {/* <span>{title}</span>
<Button
  type="button"
  iconOnly
  variant="ghost"
  onClick={onClose}
  size="sm"
  className="size-7"
>
  <XMarkIcon />
</Button> */}
    </CardHeader>
  )
}

const Footer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <CardFooter
      data-slot="nmw-footer"
      className={cn(
        'flex flex-row justify-end gap-2 border-t px-4 py-4',
        className,
      )}
      {...props}
    ></CardFooter>
  )
}

const Body = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <CardContent
      data-slot="nmw-body"
      className={cn('overflow-auto px-4 py-4 text-sm', className)}
      {...props}
    ></CardContent>
  )
}

interface NonModalWindowProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  onClose: () => void
  className?: string
  as?: keyof ReactHTML
  isDirty?: boolean
  isLoading?: boolean
}

export default function NonModalWindow({
  children,
  title,
  onClose,
  className,
  isDirty = false,
  isLoading = false,
  ...props
}: NonModalWindowProps) {
  const closeToOrigin = useCloseToOrigin()
  return (
    <Card
      data-slot="nmw"
      className={cn(
        'absolute inset-0 z-auto grid h-full w-full grid-rows-[auto_1fr_auto] rounded-lg border border-light',
        className,
      )}
      {...props}
    >
      {isLoading ? (
        <>
          <Header className="animate-pulse transition-all">
            <Skeleton className="h-12 w-full" />
          </Header>
          <Body>
            <div className="flex flex-col space-y-3">
              <div className="max-h-[50vh] overflow-hidden">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((x) => (
                  <div key={x}>
                    <Skeleton className="h-3 w-[40%]" />
                    <Skeleton className="mt-2 h-6" />
                    <Skeleton className="my-4 h-0.5" />
                  </div>
                ))}
              </div>
            </div>
          </Body>
        </>
      ) : (
        <>
          {title && (
            <Header>
              {/* <CardHeader className="flex flex-row items-center justify-between overflow-auto border-b border-light px-4 py-3 font-medium"> */}
              <span>{title}</span>
              <Button
                type="button"
                iconOnly
                variant="ghost"
                onClick={() => {
                  if (isDirty) {
                    onClose()
                  } else {
                    onClose()
                    closeToOrigin()
                  }
                }}
                size="sm"
                className="size-7"
              >
                <XMarkIcon />
              </Button>
              {/* </CardHeader> */}
            </Header>
          )}

          {children}
        </>
      )}
    </Card>
  )
}
NonModalWindow.Header = Header
NonModalWindow.Body = Body
NonModalWindow.Footer = Footer
